<template>
  <AuthShell
    title="Reset Password"
    subtitle="Choose a new password."
    :show-hero="false"
  >
    <div class="auth-panel__section">
      <h2 class="auth-panel__title">Set a new password</h2>
      <p class="auth-panel__helper">Enter and confirm your new Filmsomniac password.</p>
    </div>

    <div v-if="errorMessage" class="auth-panel__section">
      <div class="auth-error-message" data-testid="reset-password-error">{{ errorMessage }}</div>
    </div>

    <form class="auth-panel__section auth-form" @submit.prevent="onSubmit">
      <div class="auth-field">
        <label class="auth-label" for="reset-password-new">New password</label>
        <input
          id="reset-password-new"
          v-model="newPassword"
          class="auth-input"
          data-testid="reset-password-new"
          type="password"
          required
          autocomplete="new-password"
        >
      </div>

      <div class="auth-field">
        <label class="auth-label" for="reset-password-confirm">Confirm password</label>
        <input
          id="reset-password-confirm"
          v-model="newPasswordConfirm"
          class="auth-input"
          data-testid="reset-password-confirm"
          type="password"
          required
          autocomplete="new-password"
        >
      </div>

      <div class="auth-actions">
        <button
          class="auth-submit"
          data-testid="reset-password-submit"
          type="submit"
          :disabled="isSubmitting"
        >
          {{ isSubmitting ? 'Saving…' : 'Save password' }}
        </button>
        <p class="auth-secondary">
          <a class="auth-link" href="/login">Back to login</a>
        </p>
      </div>
    </form>
  </AuthShell>
</template>

<script setup>
import { ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import AuthShell from '../components/AuthShell.vue'

const route = useRoute()
const router = useRouter()
const newPassword = ref('')
const newPasswordConfirm = ref('')
const errorMessage = ref('')
const isSubmitting = ref(false)

const onSubmit = async () => {
  errorMessage.value = ''
  if (newPassword.value !== newPasswordConfirm.value) {
    errorMessage.value = 'Passwords do not match.'
    return
  }
  isSubmitting.value = true
  try {
    const resp = await fetch(
      `/api/v1/auth/password-reset/${route.params.uidb64}/${route.params.token}`,
      {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          new_password: newPassword.value,
          new_password_confirm: newPasswordConfirm.value,
        }),
      },
    )
    const data = await resp.json().catch(() => ({}))
    if (!resp.ok) {
      const firstError = typeof data === 'object' ? Object.values(data)[0] : null
      errorMessage.value = Array.isArray(firstError) ? firstError[0] : firstError || data.detail || 'Password reset failed.'
      return
    }
    await router.push({
      path: '/login',
      query: { passwordChanged: '1' },
    })
  } catch (e) {
    errorMessage.value = 'Network error. Please try again.'
  } finally {
    isSubmitting.value = false
  }
}
</script>
